module.exports = __webpack_public_path__ + "static/img/toBonusPay.4df4e1da.png";